export default "__VITE_ASSET__CM2wo5R1__"